import _ from 'lodash';

import { BCMonth, UsersHourResponse } from 'api/TimeSheet/types';

import { FlatUserHours } from '../../../../../../Table/components/TableBody/helpers/types';

import { MONTH_TYPES, MonthValue } from '../../../constants';


export interface TimesheetActivitiesHours {
  [partnerId: number]: UsersHourResponse;
}

export const selectedActivitiesByHours = (
  flatUserHoursTable: FlatUserHours, 
  BCMonth: BCMonth, 
  monthType: MonthValue
) => _.reduce(flatUserHoursTable, (acc, v) => {
  if (!v) {
    return acc;
  }
  if (v?.cutDay && monthType == MONTH_TYPES.BUSINESS) {
    return acc;
  }
  const startTime = new Date(v.startTime);
  if (startTime.getMonth() + 1 != BCMonth.month && monthType == MONTH_TYPES.REGULAR) {
    return acc;
  }

  return {
    ...acc,
    [v.activity.activityId]: acc[v.activity.activityId]
      ? { ...acc[v.activity.activityId], hours: acc[v.activity.activityId].hours + v.hours }
      : { ...v, hours: v.hours },
  };
}, {} as TimesheetActivitiesHours);
